import PropTypes from 'prop-types';
import actionsSims from '../../api/actionsSims';
import { nsSimCard } from '@/app/i18n/namespaces';
import Select from '@/common-utils/components/ui/select';
import Entity from '@/common-utils/components/renders/entity/Entity';
import Spinner from '@/common-utils/components/renders/spinner/Spinner';


/**
 *
 * @param root0
 * @param root0.selectedOffer
 * @param root0.setSelectedOffer
 */
function CustomPaySelectOffer({ selectedOffer, setSelectedOffer, setSelectedOfferName }) {

    // Api calls
    const { data: offersData, isFetching, isError } = actionsSims.getSimPayviewOffers();

    return (
        <div className='my-2'>
            {
                isFetching && <Spinner className='mt-4' />
            }
            {
                !isFetching && isError &&
                <Entity entity='modal.custom_pay_multiple_activation.error_offers' namespace={nsSimCard} />
            }
            {
                !isFetching && offersData &&
                <>
                    <div>
                        <Entity entity='modal.custom_pay_multiple_activation.labels.offer' namespace={nsSimCard} />
                    </div>
                    <Select
                        value={selectedOffer.value}
                        options={offersData.map((item) => ({ value: item.uuid, name: item.name }))}
                        onChange={(value) => {
                            setSelectedOffer(value);
                            setSelectedOfferName(offersData.find((item) => item.uuid === value).name);
                        }}
                        namespace={nsSimCard}
                    />
                </>
            }
        </div>
    );
}

CustomPaySelectOffer.propTypes = {
    selectedOffer: PropTypes.string,
    setSelectedOffer: PropTypes.func,
    setSelectedOfferName: PropTypes.func
};

export default CustomPaySelectOffer;